export default "__VITE_ASSET__B$bmH50Y__"